import { faCalendar, faCalendarDay, faEllipsisVertical, faFileExport, faFileImport, faPlus, faUser, faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Button, Col, Dropdown, Nav, OverlayTrigger, Row } from 'react-bootstrap'
import { ExportDataPopup } from '../../../CommonComponents/ExportDataPopup'
import { ColumnConfigurator } from '../../../CommonComponents/ColumnConfigurator'
import { Filter } from '../../../CommonComponents/Filter'
import { IconLayoutGrid, IconListDetails } from '@tabler/icons-react'
import { Form } from 'react-hook-form'
import DeleteModal from '../../DeleteModal'
import { ManageListDropdown } from '../../../CommonComponents/ManageListDropdown'
import { DeleteRequest, GetRequest, PostRequest, PutRequest } from '../../../Utils/hooks/ApiHandler'
import useLocalStorageState from 'use-local-storage-state'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import Tooltip from "@mui/material/Tooltip";
import { useGetEssentials } from '../../../Utils/hooks/useGetEssentials'
import { FilterQueryString } from '../../../CommonComponents/FilterQueryString'

const exportFieldOptions = [
    { id: "company_no", label: "Company No." },
    { id: "company_name", label: "Company Name" },
    { id: "website", label: "Website" },
    { id: "industry", label: "Industry" },
    { id: "business_type", label: "Buisness Type" },
    { id: "employee_size", label: "Employee Size" },
    { id: "owner", label: "Owner" },
    { id: "email", label: "Email" },
    { id: "phone", label: "Phone" },
    { id: "timezone", label: "Timezone" },
    { id: "address", label: "Address" },
    { id: "country", label: "Country" },
    { id: "state", label: "State" },
    { id: "city", label: "City" },
    { id: "zipcode", label: "Zipcode" },
    { id: "about", label: "About" },
    { id: "facebook", label: "Facebook" },
    { id: "twitter", label: "Twitter" },
    { id: "linkedin", label: "Linkedin" },
    { id: "instagram", label: "Instagram" },
    { id: "rating", label: "Rating" },
    { id: "created_at", label: "Created At" },
]
export const CompanyHeader = ({
    viewMode,
    heading,
    setHeading,
    showCards,
    setShowCards,
    filterCategories,
    setFilterCategories,
    setSearch,
    setActiveOffset,
    setTempFilterData,
    setCurrAdvFilter,
    columnOptions,
    filterStates,
    setFilterState,
    columns,
    setColumns,
    dropdownOptions,
    setCurrView,
    setShowCreateCompany,
    setCustomFilter,
    companyMetadata,
    filterDropdown,
    setFilterDropdown,
    filterValues,
    setCompanyFilterValues
}) => {

    const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()
    // rbac permission object
    const [PERMISSION, _] = useLocalStorageState('permission')

    // company rbac permission
    const companyGrants = PERMISSION?.company

    // export popup state
    const [exportPop, setExportPop] = useState(false)
    // export fields state to pass the set of final fields to export data 
    const [exportFields, setExportFields] = useState(exportFieldOptions)

    // filter states for searching function within the filter categories dropdown in header
    // filter seazrch bar input state
    const [filterSearchInput, setFilterSearchInput] = useState("")
    // Add states for filter pagination and search
    const [filterOffset, setFilterOffset] = useState(0)
    const [filterLimit, setFilterLimit] = useState(5)
    const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("")
    const [filterPageCount, setFilterPageCount] = useState(0)

    // for searching throught whole companies
    const [inputSearch, setInputSearch] = useState("")

    const [editValue, setEditValue] = useState()
    const [editingFilterId, setEditingFilterId] = useState(null)
    // filter state to store the data to pass to delete and edit handler for filter
    const [filterData, setFilterData] = useState(null)
    // delete modal loading state
    const [loading, setLoading] = useState(false)

    // delete state for filter
    const [confirmFilterDelete, setFilterDelete] = useState(false)
    // debouncing filter cards search input
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedFilterSearch(filterSearchInput)
            setFilterOffset(0) // Reset to first page when search changes
        }, 300)

        return () => clearTimeout(timer)
    }, [filterSearchInput])
    // debouncing company search input
    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            setSearch(inputSearch.trim())
            setActiveOffset(0)
        }, 300)

        return () => clearTimeout(debounceTimer)
    }, [inputSearch])


    const subFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "contains", label: "Contains" },
        { value: "not_contains", label: "Not-Contains" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
        { value: "is_empty", label: "Is Empty" },
        { value: "is_not_empty", label: "Is Not Empty" },
        { value: "begins_with", label: "Begins With" },
        { value: "between", label: "Between" },
    ]

    const customSubFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "is_set", label: "Is Set" },
        { value: "is_not_set", label: "Is Not Set" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
    ]

    const companyImportFields = [
        // { id: "company_no", label: "Company No.", required: true },
        { id: "company_name", label: "Company Name", required: true },
        { id: "website", label: "Website", required: false },
        { id: "industry", label: "Industry", required: true },
        { id: "business_type", label: "Buisness Type", required: false },
        { id: "owner", label: "Owner", required: true },
        { id: "employee_size", label: "Employee Size", required: false },
        { id: "email", label: "Email", required: true },
        { id: "phone", label: "Phone", required: true },
        { id: "address", label: "Address", required: false },
        { id: "country", label: "Country", required: true },
        { id: "state", label: "State", required: true },
        { id: "city", label: "City", required: true },
        { id: "zipcode", label: "Zipcode", required: false },
        { id: "about", label: "About", required: false },
        { id: "facebook", label: "Facebook", required: false },
        { id: "twitter", label: "Twitter", required: false },
        { id: "linkedin", label: "Linkedin", required: false },
        { id: "instagram", label: "Instagram", required: false },
        { id: "rating", label: "Rating", required: false },
    ]


    const companyStaticListOptions = [
        {
            key: "All Companies",
            icon: <FontAwesomeIcon
                icon={faUser}
                style={{ width: "13px", height: "13px", marginRight: "9px" }}
            />
        },
        {
            key: "Companies Created By Me",
            icon: <FontAwesomeIcon
                icon={faUserPlus}
                style={{ width: "15px", height: "15px", marginRight: "9px" }}
            />
        },
        {
            key: "Companies Created Today",
            icon: <FontAwesomeIcon
                icon={faCalendarDay}
                style={{ width: "13px", height: "13px", marginRight: "9px" }}
            />
        },
        {
            key: "Companies Created this Month",
            icon: <FontAwesomeIcon
                icon={faCalendar}
                style={{ width: "13px", height: "13px", marginRight: "9px" }}
            />
        },
    ]


    // filter card page change
    const handleFilterPageChange = (newOffset) => {
        setFilterOffset(newOffset.selected)
    }

    const handleFilterEdit = async (filter) => {
        try {
            if (!editValue?.trim()) return
            if (!filter) return

            const updatePayload = {
                customer_id: customerId,
                user_login_id: loginUserId,
                filter_id: filter.id,
                card_name: editValue,
                description: "",
                module_name: "company"
            }

            const res = await PutRequest(
                "common/updateFilterName",
                updatePayload,
                { headers },
                extras
            )

            if (res?.status === "fail" || res?.success === false) {
                toast.error(res?.message || "Error Updating Filter")
                setFilterDropdown(false)
                return
            }

            setHeading(editValue.trim())
            // setIsEditing(false)
            setEditingFilterId(null)
            setFilterDropdown(false)
            fetchFilterCategories()
            toast.success(res?.message)
            return
        } catch (error) {
            toast.error("Error Updating Filter")
        }
    }
    // delete handler for filter delete
    const handleFilterDelete = async () => {
        setLoading(true)
        try {
            if (filterData === null) return
            const res = await DeleteRequest(
                `company/deleteFilter/${filterData.id}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )
            if (res.status === "fail") {
                toast.error(res.message)
                return
            }
            if (res.success === false) {
                toast.error("Error Deleting Filter")
            }
            setCustomFilter(null)
            setLoading(false)
            setFilterDropdown(false)
            setFilterDelete(false)

            setHeading("All Companies")
            filterCategories?.length !== 1 && fetchFilterCategories()
            filterCategories?.length === 1 && setFilterOffset(0)
            localStorage.setItem("companyMetadata", JSON.stringify({
                ...companyMetadata,
                filterType: {
                    filterName: "All Companies",
                    id: null
                }
            }))
            toast.success(res.message)
        } catch (error) {
            setLoading(true)
            toast.error("Error Deleting Filter")
        }
    }

    const fetchFilterCategories = async () => {
        try {
            const res = await GetRequest(
                `company/fetchFilterCards/${customerId}/${loginUserId}?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )

            if (res.status === "fail" || res.success === false) {
                // toast.error(res.message)
                return
            }
            setFilterCategories(res.data)
            // Calculate page count if total_count is available in response
            if (res.total_count) {
                setFilterPageCount(Math.ceil(res.total_count / filterLimit))
            }
        } catch (error) {
            // toast.error()
            return
        }
    }
    useEffect(() => {
        fetchFilterCategories()
    }, [
        heading,
        filterOffset,
        filterLimit,
        debouncedFilterSearch,
    ])

    return (
        <>
            <div className="d-flex justify-content-between align-content-center px-0 w-100 py-2">
                {/* company div */}
                <div
                    className="d-flex align-items-center gap-1"
                    style={{ zIndex: 101 }}
                >
                    <h3
                        className="mb-0 me-1"
                        style={{ fontWeight: 200, fontSize: "22px", textTransform: "capitalize" }}
                    >
                        {heading}
                    </h3>

                    {/* heading filter dropdown */}
                    <ManageListDropdown
                        heading={heading}
                        setHeading={setHeading}
                        categories={filterCategories}
                        storageKey="companyMetadata"
                        metadata={companyMetadata}
                        setTempFilterData={setTempFilterData}
                        onEdit={(c) => setFilterData(c)}
                        onDelete={(c) => {
                            setFilterData(c)
                            setFilterDelete(true)
                        }}
                        onUpdate={(c) => {
                            setFilterData(c)
                            handleFilterEdit(c)
                        }}
                        staticOptions={companyStaticListOptions}
                        filterOffset={filterOffset}
                        setFilterOffset={setFilterOffset}
                        handleFilterPageChange={handleFilterPageChange}
                        filterPageCount={filterPageCount}
                        filterLimit={filterLimit}
                        editValue={editValue}
                        setEditValue={setEditValue}
                        editingFilterId={editingFilterId}
                        setEditingFilterId={setEditingFilterId}
                        canEdit_canDownload={true}
                        setCustomFilter={setCustomFilter}
                        filterQueryKey={"companyApplyFilterQueryValues"}
                        setCurrAdvFilter={setCurrAdvFilter}
                    />

                    {confirmFilterDelete && (
                        <DeleteModal
                            show={confirmFilterDelete}
                            onClose={() => setFilterDelete(false)}
                            onConfirm={() => handleFilterDelete(filterData)}
                            message="Are you sure you want to delete this item?"
                            isLoading={loading}
                        ></DeleteModal>
                    )}
                    <div className="form-check form-switch ms-3">

                        <Tooltip
                            id="tooltip-top"
                            title={showCards ? "Show company card" : "Hide company card"}
                        >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                role="switch"
                                checked={showCards} // Changed from !showCards to showCards
                                onChange={() => setShowCards(!showCards)}
                            />
                        </Tooltip>
                    </div>
                </div>

                {/* form actions div */}
                <div
                    className="d-flex align-content-center gap-1"
                    style={{ height: "35px" }}
                >
                    <div className=" position-relative">
                        <i
                            className="fa-solid fa-magnifying-glass"
                            style={{
                                position: "absolute",
                                marginLeft: "13px",
                                fontSize: 12,
                                marginTop: 11,
                            }}
                        ></i>
                        <input
                            className="form-control h-100"
                            type="text"
                            placeholder='Search Here...'
                            style={{ fontSize: "12px", paddingLeft: "36px" }}
                            onChange={(e) => {
                                setInputSearch(e.target.value)
                                setActiveOffset(0)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault()
                                    setSearch(inputSearch)
                                    setActiveOffset(0)
                                }
                            }}
                        />
                    </div>
                    <div
                        className=" px-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 5,
                            border: "1px solid #7a3a5e69",
                            borderRadius: "3px",
                            background: "#ffffff",
                            padding: "4px 8px",
                        }}
                    >
                        {/* Card View Button */}
                        <button
                            type='button'
                            style={{
                                border: 'none',
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor:
                                    viewMode === "card" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                            }}
                            onClick={() => setCurrView("card")}
                        >
                            <IconLayoutGrid
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: "#212121",
                                }}
                            />
                        </button>

                        {/* List View Button */}
                        <button
                            type='button'
                            style={{
                                border: 'none',
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor:
                                    viewMode === "list" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                            }}
                            onClick={() => setCurrView("list")}
                        >
                            <IconListDetails
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: "#212121",
                                }}
                            />
                        </button>
                    </div>
                    {/* advance filtering */}
                    <Filter
                        canEdit_canDownload={true}
                        dropdownOptions={dropdownOptions}
                        filterState={filterStates}
                        setFilterState={setFilterState}
                        filterDropdown={filterDropdown}
                        setFilterDropdown={setFilterDropdown}
                        setHeading={setHeading}
                        subFilter={subFilter}
                        customSubFilter={customSubFilter}
                        applyQuery={"company/applyFilter"}
                        setTempFilterData={setTempFilterData}
                        setCurrAdvFilter={setCurrAdvFilter}
                        filterEndpoint={"company/filterQuery"}
                        view={viewMode == "table" ? "list" : "card"}
                        setOffset={setActiveOffset}
                        setCustomFilter={setCustomFilter}
                        storageKey={'companyMetadata'}
                        metadata={companyMetadata}
                        filterQueryKey={"companyApplyFilterQueryValues"}
                    ></Filter>

                    {/* Gear icon dropdown with drag and drop */}
                    {viewMode === "list" &&
                        <ColumnConfigurator
                            columnOptions={columnOptions}
                            columns={columns}
                            setColumns={setColumns}
                            metadata={companyMetadata}
                            storageKey="companyMetadata"
                        />
                    }
                    <Dropdown
                        as="div"
                        className="dropdownsWithoutToggle"
                    >
                        <Dropdown.Toggle as={Nav.Link} className="header-link">
                            <button
                                className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                                style={{
                                    fontSize: "1rem",
                                    alignItems: "center",
                                    height: "35px",
                                    width: "2.5rem",
                                }}
                            >
                                {" "}
                                <FontAwesomeIcon
                                    style={{
                                        width: "15px",
                                        height: "15px",
                                    }}
                                    icon={faEllipsisVertical}
                                />
                            </button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            className="defaultDropdown dropdown-menu-end "
                            style={{
                                width: "11rem",
                                padding: "12px 0px",
                                right: "3.4rem",
                            }}
                        >
                            <Dropdown.Item
                                onClick={() => {
                                    if (!companyGrants?.isImport) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    navigate("/importdata", {
                                        state: {
                                            module_name: "company",
                                            fieldData: [{
                                                title: "General Fields",
                                                fields: companyImportFields.map(c => c)
                                            }]
                                        }
                                    })
                                }}
                                href="#" className="d-flex align-items-center">
                                <FontAwesomeIcon
                                    icon={faFileImport}
                                    style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "9px",
                                        color: "#5e5f60",
                                    }}
                                />{" "}
                                Import Data
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    if (!companyGrants?.isExport) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    setExportPop(true)
                                }}
                                className="d-flex align-items-center"
                            >
                                <FontAwesomeIcon
                                    icon={faFileExport}
                                    style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "9px",
                                        color: "#5e5f60",
                                    }}
                                />{" "}
                                Export Data
                            </Dropdown.Item>
                            {exportPop && (
                                <ExportDataPopup
                                    exportPop={exportPop}
                                    setExportPop={setExportPop}
                                    exportfields={exportFields}
                                    setExportfields={setExportFields}
                                    heading={"Export Company Data"}
                                    handleClose={() => setExportPop(false)}
                                    exportData={exportFields.map((c) => c.id)}
                                    module_name="company"
                                    fields={exportFieldOptions}
                                    selectedFields={exportFields}
                                />
                            )}
                        </Dropdown.Menu>
                    </Dropdown>

                    <Button
                        type="button"
                        className="btn btn-default"
                        style={{
                            height: "34px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => {
                            if (!companyGrants.isCreate) {
                                toast.warning("You are not authorized for this action!")
                                return
                            }
                            setShowCreateCompany(true)
                        }
                        }
                    >
                        <FontAwesomeIcon icon={faPlus} className="pe-1" /> Add
                    </Button>
                </div>
                {/* </Form> */}
            </div >
            {/* to show the current applied filters  */}
            <FilterQueryString
                filterValues={filterValues}
                setCurrAdvFilter={setCurrAdvFilter}
                setTempFilterData={setTempFilterData}
                setFilterState={setFilterState}
                setFilterValues={setCompanyFilterValues}
            />
        </>
    )
}
